exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-10p {\n  width: 10px;\n}\n.primary-field-width {\n  width: 250px;\n}\n@media only screen and (max-width: 1444px) {\n.mw-300 {\n    max-width:300px\n}\n.w-10p {\n    width: 5px;\n}\n.primary-field-width {\n    width: 105px;\n}\n.w-selects {\n    width:145px;\n}\n.plaka-bilgileri-table td {\n    padding: 5px !important;\n}\n.notes-container {\n    width: 110px;\n}\n}\n\n\n", ""]);

// exports
